import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../lib/utilis/index";
import { NewAuthService } from "./service";
import { UserDTO, UserInfoDTO } from "../user/dto";


interface AuthState {
    findMeUserStatus: PromiseStatuses
    findMeUserResponse?: UserDTO
    avatar: boolean
    findByUserIdStatus: PromiseStatuses
    findByUserIdResponse?: UserInfoDTO[]
}

const initialState: AuthState = {
    avatar: true,
    findByUserIdStatus: 'idle',
    findMeUserStatus: "idle"
}

export const findMeUser = createAsyncThunk(
    'auth/findMeUser',
    async (_, thunkApi): Promise<UserDTO> => {
        const authService = NewAuthService()
        return authService.findMeUser().catch((error: any) => {
            if (error.response.status === 401) {
                //keycloak.login()
            }
            throw (thunkApi.rejectWithValue(error))
        })
    }
)

export const findByUserId = createAsyncThunk(
    'auth/findByUserId',
    async (request: string[], thunkApi): Promise<UserInfoDTO[]> => {
        let promises: Promise<UserInfoDTO>[] = []
        promises = request.map(async (id) => {
            const authService = NewAuthService()

            return authService.findByUserId(id)
        })
        return Promise.all(promises)
    }
)

const authSlice = createSlice({
    name: 'auth/slice',
    initialState,
    extraReducers(builder) {
        builder
            .addCase(findByUserId.pending, (state) => {
                state.findByUserIdStatus = 'loading'
            })
            .addCase(findByUserId.fulfilled, (state, action) => {
                state.findByUserIdStatus = 'successfully'
                state.findByUserIdResponse = action.payload
            })
            .addCase(findByUserId.rejected, (state) => {
                state.findByUserIdStatus = 'failed'
            }).addCase(findMeUser.fulfilled, (state, action) => {
                state.findMeUserResponse = action.payload
                state.findMeUserStatus = 'successfully'
            }).addCase(findMeUser.pending, (state) => {
                state.findByUserIdStatus = 'loading'
            }).addCase(findMeUser.rejected, (state) => {
                state.findByUserIdStatus = 'failed'
            })
    },
    reducers: {
        setFindMeUserStatus: (state, action) => {
            state.findMeUserStatus = action.payload
        },
    },
})

export const {
    setFindMeUserStatus
} = authSlice.actions

export default authSlice.reducer